; (function (jQuery) {

	"use strict";

	function MemberzoneNav() {
		var fn = {
			init: function () {
				jQuery('.memberzone-header__toggle').on('click', fn.toggle);
			},

			toggle: function() {
				const body = jQuery('body');
				const toggleText = jQuery('.memberzone-header__toggle-inner span');

				body.toggleClass('is-nav-open');
				toggleText.text() === 'Menu' ? toggleText.text('Close') : toggleText.text('Menu');
			}
		}

		jQuery(fn.init);
	}

	new MemberzoneNav();
})(jQuery);